import { render, staticRenderFns } from "./DeviceSettings.vue?vue&type=template&id=3ccb6906&scoped=true"
import script from "./DeviceSettings.vue?vue&type=script&lang=js"
export * from "./DeviceSettings.vue?vue&type=script&lang=js"
import style0 from "./DeviceSettings.vue?vue&type=style&index=0&id=3ccb6906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccb6906",
  null
  
)

/* custom blocks */
import block0 from "./DeviceSettings.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports